import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import css from './checkbox.module.css';
import FormField from '../../common/form-field';
import { parseError } from '../../../services/utils';
import readInputCss from './read-input.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';

export default function Checkbox(
  name: string,
  label: string = null,
  horizontal?: boolean,
  className?: string,
  column: boolean = false
): FormComponent {
  return ({ ...rest }) => (
    <CheckboxComponent
      name={name}
      label={label}
      {...rest}
      horizontal={horizontal}
      className={className}
      column={column}
    />
  );
}

export function CheckboxComponent({
  name,
  label,
  parentName,
  readonly,
  disabled,
  horizontal = false,
  className = '',
  column,
}: FormComponentProps & {
  name: string;
  label: string;
  horizontal?: boolean;
  className?: string;
  column: boolean;
}) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const checkboxName = parentName ? `${parentName}.${name}` : name;
  const error = parseError(checkboxName, errors);

  if (readonly) {
    return (
      <FormField
        label={column ? null : ' '}
        error={error ? error.message : null}
        labelFor={checkboxName}
        horizontal={horizontal}
        className={className}
        column={column}
      >
        <Controller
          name={checkboxName}
          defaultValue={false}
          render={({ field }) => (
            <div
              className={`${css[column ? 'column' : '']} ${css['readonly']} ${
                readInputCss['readonly']
              } ${css[field.value ? 'true' : 'false']}`}
            >
              <div>
                {field.value ? (
                  <FontAwesomeIcon icon={faCheck} data-name={checkboxName} />
                ) : (
                  <FontAwesomeIcon icon={faTimes} data-name={checkboxName} />
                )}
              </div>
              <label htmlFor={checkboxName}>{label ? t(label) : t(name)}</label>
            </div>
          )}
        />
      </FormField>
    );
  } else {
    return (
      <FormField
        label={column ? null : ' '}
        error={error ? error.message : null}
        labelFor={checkboxName}
        horizontal={horizontal}
        className={className}
        column={column}
      >
        <div className={css[column ? 'column' : '']}>
          <input
            type="checkbox"
            id={checkboxName}
            name={checkboxName}
            className={css['checkbox']}
            {...register(checkboxName)}
            disabled={disabled || readonly}
            readOnly={readonly}
          />
          <label htmlFor={checkboxName} className="ml-2">
            {label ? t(label) : t(name)}
          </label>
        </div>
      </FormField>
    );
  }
}
